import { BareActionContext, getStoreBuilder } from "vuex-typex";
import { RootState } from "./index";
import { DeliveryModel } from "@/models/deliveryModel";
import preloadState from "../services/PreloadState";
import { TotalValueOfGoodsModel } from "@/models/Cart";

export interface DeliveriesState {
    deliveries: DeliveryModel;
    totalValueOfGoods: TotalValueOfGoodsModel;
}

const initialState: DeliveriesState = {
    deliveries: preloadState.deliveries,
    totalValueOfGoods: preloadState.totalValueOfGoods
};

const store = getStoreBuilder<RootState>().module("deliveries", initialState);

function deliveries(state: DeliveriesState) {
    return state.deliveries;
}

function totalValueOfGoods(state: DeliveriesState) {
    return state.totalValueOfGoods;
}

// getters
const getDeliveries = store.read(deliveries, "deliveries");
const getTotalValueOfGoods = store.read(totalValueOfGoods, "totalValueOfGoods");

// mutations
function commitDeliveries(state: DeliveriesState, payload: DeliveryModel) {
    state.deliveries = payload;
}

function commitTotalValueOfGoods(state: DeliveriesState, payload: TotalValueOfGoodsModel) {
    state.totalValueOfGoods = payload;
}

// actions
async function dispatchDeliveries(context: BareActionContext<DeliveriesState, RootState>, curDeliveries: DeliveryModel) {
    commitDeliveries(context.state, curDeliveries);
}

async function dispatchTotalValueOfGoods(context: BareActionContext<DeliveriesState, RootState>, curDeliveries: TotalValueOfGoodsModel) {
    commitTotalValueOfGoods(context.state, curDeliveries);
}


export const deliveriesStore = {
    get deliveries() { return getDeliveries(); },
    get totalValueOfGoods() { return getTotalValueOfGoods(); },
    commitDeliveries: store.commit(commitDeliveries, "commitDeliveries"),
    commitTotalValueOfGoods: store.commit(commitTotalValueOfGoods, "commitTotalValueOfGoods"),
    dispatchDeliveries: store.dispatch(dispatchDeliveries, "dispatchDeliveries"),
    dispatchTotalValueOfGoods: store.dispatch(dispatchTotalValueOfGoods, "dispatchTotalValueOfGoods"),
};
